import { Dropdown, Layout } from 'antd';
import { KoDP, KoText, KoLoader } from 'packages';
import KoIcon from '@kwapio/icons';
import { useEffect,  useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { deleteCookie, getCookie } from 'shared/utils/cookies';
import { accountAPI } from 'pages/account/account.service';
import {
  getDepartments,
  getDesignations,
  getGroups,
  getHolidays,
  getSettings, getUserById,
  getUsers
  // getWorkspace
} from "shared/store/slice";
import styles from './layouts.module.scss';
import { getMenuForRoles } from './getmenu';
import { updateUser, login } from 'shared/store/authSlice';
import Subscriptions from 'pages/account/subscriptions';
import GlobalTicketSearch from './globalTicketSearch';

const { Header } = Layout;

function GlobalHeader(props) {
  const userById = useSelector(state => state?.userById);
  const [isLoading, setLoading] = useState(false);
  const [openSunscriptions, setOpenSubscriptions ] = useState(false);
  // const [, setGloableSearchResult] = useState();
  let userDetails = userById['data'];
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { pathname } = location;
  const accountById = useSelector(state => state?.accountById);
  const currentPath = pathname?.split('/')[1];
  const [activeLink, setActiveLink] = useState(currentPath);
  const accountDetails = accountById['data'];
  const subscription = useSelector(state => state.subscription);

  console.log('subscription', subscription);
  // useEffect(() => {
  //   if (Notification.permission !== 'granted') {
  //     Notification.requestPermission();
  //   }
  // }, []);



  useEffect(() => {
    if (getCookie('userId')) {
      dispatch(getUsers());
      dispatch(getGroups());
      dispatch(getDesignations());
      dispatch(getDepartments());
      dispatch(getHolidays());
      dispatch(getSettings(getCookie('accountId')));
      dispatch(getUserById(getCookie('userId')));
    }
  }, []);

  useEffect(() => {
    setActiveLink(currentPath);
  }, [currentPath]);

  // const debounceFetcher = useMemo(() => {
  //   const loadOptions = (value) => {
  //     setGloableSearchResult([]);
  //     getGloableSearchData(value);
  //   };
  //   return _debounce(loadOptions, 800);
  // }, [800]);

  // const getGloableSearchData = (value) => {
  //   accountAPI.getGloableSearchData({search: value}).then((res) => {
  //     setGloableSearchResult(res);
  //   });
    
  // };


  // const SearchInput = () => {
  //   return (
  //     <div
  //       key="SearchOutlined"
  //       aria-hidden
  //       className={styles.search}
  //       onMouseDown={(e) => {
  //         e.stopPropagation();
  //         e.preventDefault();
  //       }}
  //     >
  //       <KoInput
  //         className={styles.searchBox}
  //         onChange={(e) => debounceFetcher(e.target.value)}
  //         allowClear
  //         prefix={
  //           <KoIcon name='SearchOutlined'
  //             width={16}
  //             height={16}
  //           />}
  //         placeholder="search task or actions (Ex: Apply Leave, Attendance Approvals)"
  //         variant={'borderless'} />
  //       {/* <KoSelect
  //         onChange={v => getGloableSearchData(v)}
  //         showSearch
  //         onSearch={debounceFetcher}
  //         allowClear
  //         placeholder='Select spec'
  //         options={gloablResult?.map((sp) => ({
  //           label: sp?.name,
  //           value: sp?.documentId
  //         }))}
  //       />; */}
  //       <KoIcon name='PlusFilled'
  //         width={29}
  //         height={29}
  //       />
  //     </div>
  //   );
  // };


  const logout = () => {
    deleteCookie("accessToken", "", 0);
    deleteCookie("userId", "", 0);
    deleteCookie("storeId", "", 0);
    deleteCookie("accountId", "", 0);
    deleteCookie("name", "", 0);
    navigate('/');
    window.location.reload();
  };



  const switchAccount=(account)=>{
    setLoading(true);
    accountAPI.switchAccount(account).then(
      (data) => {
        setLoading(false);
        if(data?.status === 2){
          navigate(`/account/requested`);
          return;
        }
        if(!data?.isVerified){
          navigate('/account/verify');
        } else if(data?.isChangePassword){
          navigate('/account/resetpassword');
        }else{
          const urlParams = new URLSearchParams(window.location.search);
          const redirectUrl = urlParams.get('redirect');
          if (redirectUrl) {
            window.location.href = redirectUrl;
          } else {
            dispatch(updateUser({...data}));
            dispatch(
              login({
                userId: data.userId,
                user: data.user,
                accessToken: data.accessToken,
                accountId: data.accountId
              })
            );
            navigate('/home/feed');
            window.location.reload();
          }
        }
      },
      (err) => {
        setLoading(false);
      }
    );

  };


  return (
    <>
      {isLoading && <KoLoader/>}
      <Header className={styles.shallowHeader}>
      </Header>
      <Header className={`${styles.header}`}>
        <div className={styles.topNavHeader}>
          <div className={styles.topNavHeaderMain}>
            <div className={styles.topNavHeaderMainLeft} onClick={() => navigate('/home/feed')}>
              <div className={styles.logo}>
                <KoIcon name='AppLogoFilled' width={115} height={25} />
              </div>
            </div>
            <div className={`${styles.topNavHeaderMenu} topNav`}>
              <ul>
                {getMenuForRoles(userDetails).map((item) => {
                  if (item.active) {
                    return (
                      <li key={item.key} className={(activeLink === item.key || (item.key === 'workspaces' && activeLink === 'workspace')) ? styles.active : ''}>
                        <Link to={item.link}>
                          {/* { item.key === 'chat' &&
                            <span className={styles.chatCount}>
                              <span className={styles.count}>2</span>
                            </span>
                          } */}
                          <KoIcon name={item.icon} />
                          <KoText ellipsis={true} className={styles.text} text={item.text} />
                        </Link>
                      </li>
                    );
                  }
                  return null;
                })}

              </ul>

            </div>

            {/* {subscription?.remainingTrialDays <= 0 && <div className={styles.headerRightContentUpgrade}>
              <KoIcon name="LogOutlined" className={styles.pulseIcon} />
              <div className={styles.headerRightContentUpgradeBtn}>
                <KoText text={`${subscription?.remainingTrialDays !== 0 ? subscription?.remainingTrialDays + ' days left in your trial — ' : 'Your trial has ended — keep your access'}`} />
                <KoText text="upgrade now!" className={styles.upgradeBounce} onClick={() => { setOpenSubscriptions(true); }} />
              </div>
            </div>} */}
            
            <div className={styles.headerBtnRightContent}>
              {/* <Badge size={'small'} dot={true} offset={[-1, 1]}>
                <Button shape="circle" icon={<KoIcon className={styles.iconshake}  name={true ? 'NotificationAlertOutlined' : 'NotificationOutlined'}
                  width={20} height={20} />} />
              </Badge> */}
              <GlobalTicketSearch fetchTickets={accountAPI.getGloableSearchData} />
            </div>
            <div className={styles.headerActionsAvatar}>
              <Dropdown
                overlayClassName={styles.settings}
                popupRender={(menu) => (
                  <div className={styles.customDropdown}>
                    <div className={styles.customDropdownContnet}>
                      <ul>
                        <li onClick={() => navigate(`/profile/${userDetails?.userId}`)}>
                          <KoIcon name={'ActiveUseresOutlined'} />
                          <Link to={`/profile/${userDetails?.userId}`}> <KoText text={'My profile'} /></Link>
                        </li>
                        {/* <li>
                          <KoIcon name={'SettingsOutlined'} />
                          <KoText text={'Account managemnet'} />
                        </li> */}

                        {/* <li onClick={() => navigate(`/admin/settings`)}>
                          <KoIcon name={'SettingsOutlined'}  width={18} height={18}/>
                          <KoText text={'Admin Console'} />
                        </li>*/}

                        <li onClick={() => navigate(`/account/changepassword/${userDetails?.email}`)}>
                          <KoIcon name={'ChangePasswordOutlined'}  width={18} height={18}/>
                          <Link to={`/account/changepassword/${userDetails?.email}`}> <KoText text={'Change password'} /></Link>
                        </li>
                        <li onClick={logout}>
                          <KoIcon name={'LogoutOutlined'}  width={18} height={18}/>
                          <KoText text={'Sign out'}/>
                        </li>
                      </ul>
                      {userDetails?.userAccount&& <KoText className={styles.switchAccountText} text='SWITCH ACCOUNT' />}
                      <ul className={styles.switchAccount}>
                        {
                          userDetails?.userAccount?.map((account)=>
                            <li onClick={()=>switchAccount(account)} key={account.accountId} className={styles.userWrapperSwitch}>
                              <div className={`${styles.headCircle}  ${styles[account ?
                                account?.companyName?.charAt(0).toLowerCase() : 'a']}`}>

                                {account?.['logo'] ?

                                  <KoDP shape={'default'} logo={account?.logo} width={account?.logo?.[0]?.name ? 25 : 25} height={account?.companyName?.logo?.[0]?.name ? 25 : 25} />
                                  :
                                  <KoText className={`${styles.letter}`} text={account?.companyName?.charAt(0)} />
                                }
                              </div>
                              <div className={styles.accounts}>
                                <KoText ellipsis={true} className={styles.domain} text={`${account?.companyName}`} />
                                <KoText ellipsis={true} className={styles.subdomain} text={`https://${account?.domain}.kwapio.com`} />
                              </div>
                              {getCookie('accountId') === account?.accountId && <div className={styles.circleActive}></div>}
                            </li>
                          )
                        }
                      </ul>
                    </div>
                  </div>
                )}
                placement={'bottomRight'}>
                <span>
                  <div className={styles.userWrapper} >
                    {/* {accountDetails?.logo &&<div className={styles.logo}>
                    <KoImage src={accountDetails?.logo[0].url} width={115} height={25} />
                  </div>} */}
                    {accountDetails?.companyName && <KoText ellipsis={true} className={styles.name} text={`${accountDetails?.companyName}.`} />}
                    {/* <KoBadge dot={true} size={'small'} offset={[-4, 26]} color={'status' === 'online' ? 'var(--palette-success-main)' : 'var(--palette-error-main)'}> */}
                    <div className={`${styles.headCircle}  ${styles[userDetails ?
                      userDetails?.profile?.firstName?.charAt(0).toLowerCase() : 'a']}`}>

                      {userDetails?.profile?.['logo'] ?

                        <KoDP shape={'circle'} logo={userDetails?.profile?.logo} width={userDetails?.profile?.logo?.[0]?.name ? 30 : 30} height={userDetails?.profile?.logo?.[0]?.name ? 30 : 30} />
                        :
                        <KoText className={`${styles.letter}`} text={userDetails?.profile?.firstName?.charAt(0)} />
                      }
                    </div>
                    {/* </KoBadge> */}
                  </div>
                </span>
              </Dropdown>

            </div>
          </div>
        </div>
      </Header>
      {openSunscriptions && <Subscriptions setOpenSubscriptions={setOpenSubscriptions} openSunscriptions={openSunscriptions} />}
    </>
  );
}

export default GlobalHeader;